"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createReduce = _interopRequireDefault(require("./_createReduce.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// The right-associative version of reduce, also known as `foldr`.
var _default = exports.default = (0, _createReduce.default)(-1);